import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";

import Carousel from "react-bootstrap/Carousel";
import BG from "../assets/images/Banner Section.png";

const HeroCarousel = () => {
  const dispatch = useDispatch();
  const [index, setIndex] = useState(0);
  const configData = useSelector((state) => state.config.data);
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    console.log("configData?.banners.length: ", configData);
    if (configData?.banners.length > 0) {
      setBanners(configData?.banners);
    } else {
      setBanners([{ image: BG }, { image: BG }, { image: BG }]);
    }
  }, [configData]);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <Carousel activeIndex={index} onSelect={handleSelect}>
      {banners.map((item, index) => (
        <Carousel.Item key={index}>
          <img src={item.image} width={"100%"} />
          <Carousel.Caption></Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};
HeroCarousel.prototype = {
  name: PropTypes.string,
  title: PropTypes.string,
};

export default HeroCarousel;
